const translation = {
  Product: "পণ্য",
  "Header.productNav": "LUKKEY পণ্য",
  Feature: "বৈশিষ্ট্য",
  "About Us": "আমাদের সম্পর্কে",
  FAQ: "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
  "Privacy Policy": "গোপনীয়তা নীতি",
  "Help Center": "সহায়তা কেন্দ্র",
  "Header.infoMenu": "আরও",
  "Header.appNow": "অ্যাপ নিন",
  "Header.appModal.title": "এখনই LUKKEY অ্যাপ ব্যবহার করুন",
  "Header.appModal.subtitle": "অফিশিয়াল LUKKEY মোবাইল অ্যাপ পেতে আপনার প্ল্যাটফর্ম বেছে নিন।",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "iPhone-এ অফিসিয়াল অ্যাপ ইনস্টল করুন।",
  "Header.appModal.iosButton": "খুলুন",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Google Play থেকে অফিসিয়াল Android অ্যাপ নিন।",
  "Header.appModal.googlePlayButton": "খুলুন",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "সর্বশেষ অফিসিয়াল APK সরাসরি ডাউনলোড করুন।",
  "Header.appModal.androidButton": "ডাউনলোড",
  "Header.appModal.note": "শুধু অফিসিয়াল মোবাইল ডাউনলোড। সর্বশেষ সংস্করণের জন্য উপরের লিংক ব্যবহার করুন।",
  "Academy": "একাডেমি",
  "Legal": "আইনি তথ্য",
  "AboutUs.title": "LUKKEY সম্পর্কে",
  "AboutUs.lede": "LUKKEY একটি সুইস হার্ডওয়্যার ওয়ালেট ব্র্যান্ড, যা ডিজিটাল সম্পদের মালিকানার জন্য সর্বোচ্চ নিরাপত্তা মান তৈরি করতে নিবেদিত।",
  "AboutUs.vision.closing": "আপনার চাবি। আপনার সম্পদ। আপনার ভবিষ্যৎ।",
  "AboutUs.quote": "LUKKEY মানুষ ও ডিজিটাল সম্পদের মধ্যে নিরাপত্তার স্তর তৈরি করে।",
  "AboutUs.block1": "LUKKEY সুইজারল্যান্ডভিত্তিক। এটি নিরাপদ self-custody-এর জন্য ডিজাইন করা হার্ডওয়্যার ওয়ালেটের ওপর ফোকাস করে।",
  "AboutUs.block2": "এর পণ্যগুলো secure element, anti-tamper protection এবং সম্পূর্ণ offline architecture একত্রিত করে। লক্ষ্য হলো private keys-কে একটি বিচ্ছিন্ন পরিবেশে রাখা।",
  "AboutUs.block3": "সিস্টেমটি Wi‑Fi, USB বা সরাসরি নেটওয়ার্ক নির্ভরতা ছাড়া ডিজাইন করা হয়েছে। fingerprint access, NFC backup tools এবং বিস্তৃত asset support এটিকে দৈনন্দিন ব্যবহারে ব্যবহারিক রাখে।",
  "AboutUs.block5": "LUKKEY মূল firmware এবং software-এর জন্য উন্মুক্ত ও audit-যোগ্য পদ্ধতি অনুসরণ করে। নিরাপত্তা সম্পর্কিত দাবিগুলো পরিদর্শনযোগ্য ও যাচাইযোগ্য হওয়া উচিত।",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "সাপোর্ট অনুরোধ",
  "WarrantySupport.intro": "সাপোর্ট অনুরোধ জমা দিতে নিচের তথ্য পূরণ করুন।",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "সমস্যার সারাংশ",
  "WarrantySupport.form.issueTitle.placeholder": "একটি সংক্ষিপ্ত সারাংশ লিখুন",
  "WarrantySupport.form.warrantyType.label": "অনুরোধের ধরন",
  "WarrantySupport.form.warrantyType.placeholder": "অনুরোধের ধরন নির্বাচন করুন",
  "WarrantySupport.form.warrantyType.product": "ডিভাইস সমস্যা",
  "WarrantySupport.form.warrantyType.service": "অ্যাপ/অ্যাকাউন্ট সমস্যা",
  "WarrantySupport.form.warrantyType.replacement": "অন্যান্য",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "সমস্যা বা অনুরোধ বিস্তারিতভাবে লিখুন",
  "WarrantySupport.form.submit": "সাপোর্ট অনুরোধ জমা দিন",
  "WarrantySupport.alert.success": "আপনার সাপোর্ট অনুরোধ জমা হয়েছে!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "সহায়তা কেন্দ্র",
  "HelpCenter.intro":
    "LUKKEY হেল্প সেন্টারে আপনাকে স্বাগতম! আপনি যদি ক্রিপ্টোকারেন্সিতে নতুন হন বা আপনার কোল্ড ওয়ালেটের সহায়তা প্রয়োজন হয়, আপনি সঠিক জায়গায় এসেছেন। আমাদের কোল্ড ওয়ালেট সমাধান আপনার ডিজিটাল সম্পদ সংরক্ষণ ও ব্যবস্থাপনার সবচেয়ে নিরাপদ উপায় প্রদান করে। নিচে আপনি সাধারণ প্রশ্নের উত্তর ও সমস্যার সমাধানের টিপস পাবেন।",
  "HelpCenter.section4.title": "আরও সহায়তা দরকার?",
  "HelpCenter.section4.intro":
    "অনলাইনে সাপোর্ট অনুরোধ শুরু করলে সময় বাঁচবে এবং আমরা আপনাকে একজন বিশেষজ্ঞের সাথে যুক্ত করব। নিরাপত্তার জন্য, অফিসিয়াল সাপোর্ট কখনও আপনার রিকভারি ফ্রেজ বা প্রাইভেট কী চাইবে না:",
  "HelpCenter.contact.hint": "নিচের বোতাম দিয়ে সাপোর্ট অনুরোধ পাঠান, আমরা ইমেইলে যোগাযোগ করব।",
  "HelpCenter.cta.warranty": "সাপোর্ট অনুরোধ পাঠান",
  brandName: "LUKKEY",
  tagline: "আপনার ক্রিপ্টোকারেন্সি এর মতো কখনোই পরিচালনা করুন",
  description:
    "আমাদের অ্যাপ দিয়ে আর্থিক স্বাধীনতার পথে আপনার যাত্রা শুরু করুন। আমাদের উন্নত কোল্ড ওয়ালেট প্রযুক্তি দিয়ে আপনার সম্পদ সুরক্ষিত করুন এবং আরও স্মার্ট এবং কার্যকরভাবে আপনার আর্থিক অবস্থা পরিচালনা করুন। আপনার আর্থিক সুস্থতা আমাদের প্রধান অগ্রাধিকার।",
  "home.seoTitle": "LUKKEY | নিরাপদ self-custody-এর জন্য সুইস হার্ডওয়্যার ওয়ালেট",
  "home.seoDescription": "LUKKEY একটি সুইস হার্ডওয়্যার ওয়ালেট ব্র্যান্ড, যা cold wallet security, private key-এর offline সুরক্ষা, fingerprint access এবং NFC backup-এর ওপর ফোকাস করে নিরাপদ self-custody নিশ্চিত করতে সাহায্য করে।",
  learnMore: "আরও জানুন",
  "Lock Your Crypto, Securely": "আপনার ক্রিপ্টোকারেন্সি নিরাপদে লক করুন",
  Testimonials: "প্রত্যয়পত্র",
  Testimonial1:
    "আমি এই কোল্ড ওয়ালেটটি কয়েক মাস ধরে ব্যবহার করছি এবং এর নির্ভরযোগ্যতা এবং সুরক্ষা বৈশিষ্ট্যগুলি নিয়ে আমি মুগ্ধ। অত্যন্ত সুপারিশ করা হয়!",
  Testimonial2:
    "এই কোল্ড ওয়ালেটটি আমার প্রত্যাশা ছাড়িয়ে গেছে! এর ব্যবহারকারী-বান্ধব ইন্টারফেস এবং শীর্ষস্থানীয় নিরাপত্তা এটিকে যে কেউ যারা ক্রিপ্টো সম্পর্কে সিরিয়াস তাদের জন্য একটি অপরিহার্য টুল করে তোলে।",
  Testimonial3:
    "আমি আগে কয়েকটি কোল্ড ওয়ালেট চেষ্টা করেছি, তবে এটি আলাদা। এর স্লিক ডিজাইন এবং উন্নত বৈশিষ্ট্যগুলি আমার ক্রিপ্টো অ্যাসেটগুলি পরিচালনা করা অনেক সহজ করে তোলে।",
  "John Doe": "জন ডো",
  "Cryptocurrency Enthusiast": "ক্রিপ্টোকারেন্সির প্রেমিক",
  "Jane Smith": "জেন স্মিথ",
  "Crypto Security Advocate": "ক্রিপ্টো নিরাপত্তার সমর্থক",
  "Alex Johnson": "অ্যালেক্স জনসন",
  "Investment Analyst": "বিনিয়োগ বিশ্লেষক",
  "Touchscreen Interface": "টাচস্ক্রিন ইন্টারফেস",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "আমাদের সহজবোধ্য টাচস্ক্রিন ইন্টারফেস দিয়ে সহজেই ক্রিপ্টো পরিচালনা করুন, ডিজিটাল সম্পদগুলির মাধ্যমে দ্রুত এবং সহজে নেভিগেট করার জন্য ডিজাইন করা হয়েছে, দ্রুত লেনদেন এবং আপনার আঙুলের ছোঁয়ায় নিরাপদ ব্যবস্থাপনা সক্ষম করছে।",
  "Bluetooth Connectivity": "ব্লুটুথ সংযোগ",
  "Wireless syncing with your devices for real-time updates.":
    "আপনার ডিভাইসগুলির সাথে ওয়্যারলেস সিঙ্কিংয়ের মাধ্যমে রিয়েল-টাইম আপডেট পান।",
  "Airtag Tracking": "Airtag ট্র্যাকিং",
  "Track your wallet easily with built-in Airtag.":
    "নির্মিত Airtag দিয়ে আপনার মানিব্যাগ সহজেই ট্র্যাক করুন।",
  "Secure Chip Technology": "নিরাপদ চিপ প্রযুক্তি",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "এটি একটি উন্নত নিরাপত্তা চিপ দ্বারা সজ্জিত, যা আপনার মূল্যবান ডিজিটাল সম্পদের জন্য শক্তিশালী সুরক্ষা নিশ্চিত করে, অবৈধ অ্যাক্সেস এবং সাইবার হুমকির বিরুদ্ধে।",
  "Cross-Platform Support": "ক্রস-প্ল্যাটফর্ম সাপোর্ট",
  "Works with various platforms for easy accessibility.":
    "সহজ অ্যাক্সেসের জন্য বিভিন্ন প্ল্যাটফর্মের সাথে কাজ করে।",
  AboutUsDescription1:
    "LUKKEY-এ, আমরা আপনার ক্রিপ্টোকারেন্সি অ্যাসেটগুলি নিরাপদভাবে পরিচালনা করার জন্য উচ্চমানের সমাধান প্রদান করতে প্রতিশ্রুতিবদ্ধ।",
  AboutUsDescription2:
    "আমাদের সদর দপ্তর সুইজারল্যান্ডের জুগে অবস্থিত। অভিজ্ঞ পেশাদারদের একটি দল নিয়ে, আমরা ডিজিটাল মুদ্রা বাজারের অবিচ্ছিন্ন পরিবর্তনশীল প্রেক্ষাপটে উদ্ভাবন এবং অভিযোজন করার জন্য কাজ করি।",
  BlockchainNetworksSupported: "সমর্থিত ব্লকচেইন নেটওয়ার্ক",
  CryptocurrenciesSupported: "৬,০০০টিরও বেশি ক্রিপ্টোকারেন্সি সমর্থন",
  Years: "বছর",
  ExpertiseInSecurity: "সুরক্ষায় বিশেষজ্ঞতা",
  FrequentlyAskedQuestions: "ঘন ঘন জিজ্ঞাসিত প্রশ্ন",
  WhatIsColdWallet: "কোল্ড ওয়ালেট কী?",
  ColdWalletDescription:
    "কোল্ড ওয়ালেট হল একটি ধরনের ক্রিপ্টোকারেন্সি ওয়ালেট যা আপনার ডিজিটাল সম্পদ অফলাইন সঞ্চয় করে, ফলে এটি হ্যাক এবং অন্যান্য অনলাইন হুমকির বিরুদ্ধে কম সংবেদনশীল। হট ওয়ালেটের বিপরীতে, যা ইন্টারনেটের সাথে সংযুক্ত এবং ঘন ঘন লেনদেনের জন্য সুবিধাজনক, কোল্ড ওয়ালেট দীর্ঘমেয়াদী স্টোরেজের জন্য সবচেয়ে উপযুক্ত কারণ এটি উন্নত নিরাপত্তা প্রদান করে।",
  HowToSetUpColdWallet: "আপনার কোল্ড ওয়ালেট কীভাবে সেট আপ করবেন?",
  ColdWalletSetupDescription:
    "আপনার কোল্ড ওয়ালেট সেট আপ করার জন্য সাধারণত একটি নিরাপদ, অফলাইন মেশিনে ডিভাইসটি ইনিশিয়ালাইজ করা প্রয়োজন। আপনাকে একটি রিকভারি ফ্রেজ তৈরি করতে হবে এবং নিরাপদে সংরক্ষণ করতে হবে, যা ডিভাইস হারিয়ে বা ব্যর্থ হলে আপনার অ্যাসেটসে অ্যাক্সেস পেতে প্রয়োজনীয়। আপনার কেনাকাটার সাথে বিস্তারিত নির্দেশিকা প্রদান করা হয় যাতে সেটআপ প্রক্রিয়া মসৃণ হয়।",
  CryptocurrenciesCompatibleWithColdWallet:
    "কোন কোন ক্রিপ্টোকারেন্সি আপনার কোল্ড ওয়ালেটের সাথে সামঞ্জস্যপূর্ণ?",
  CryptocurrenciesCompatibilityDescription:
    "আমাদের কোল্ড ওয়ালেটগুলি বিটকয়েন, ইথেরিয়াম, লাইটকয়েন সহ প্রধান ক্রিপ্টোকারেন্সি এবং বিভিন্ন অল্টকয়েন সহ অনেকগুলি ক্রিপ্টোকারেন্সি সমর্থন করে। সমর্থিত মুদ্রার সম্পূর্ণ তালিকা জানার জন্য, আমাদের ওয়েবসাইট পরিদর্শন করুন অথবা পণ্য ডকুমেন্টেশনটি দেখুন।",
  HowToSecureColdWallet: "কিভাবে আমার কোল্ড ওয়ালেট সুরক্ষিত রাখব?",
  ColdWalletSecurityDescription:
    "আপনার কোল্ড ওয়ালেট সুরক্ষিত রাখতে, সর্বদা রিকভারি ফ্রেজটি একটি নিরাপদ এবং গোপন স্থানে রাখুন, কখনও এটি কাউকে শেয়ার করবেন না এবং অতিরিক্ত নিরাপত্তা ব্যবস্থা যেমন বায়োমেট্রিক লক বা সুরক্ষিত কনটেইনার ব্যবহার করার কথা বিবেচনা করুন। অফিসিয়াল ওয়েবসাইট থেকে নিয়মিতভাবে ওয়ালেটের ফার্মওয়্যার আপডেট করাও দুর্বলতা থেকে সুরক্ষিত রাখতে সাহায্য করবে।",
  ColdWalletNotWorking:
    "যদি আমার কোল্ড ওয়ালেট কাজ না করে বা আমি যদি কোন ত্রুটি পাই, তবে আমি কি করব?",
  ColdWalletErrorDescription:
    "যদি আপনার কোল্ড ওয়ালেটে কোন সমস্যা হয়, তবে আমাদের ব্যবহারকারী গাইডে ট্রাবলশুটিং সেকশনটি দেখুন। আরও নির্দিষ্ট সমস্যা হলে, আমাদের সাপোর্ট টিমের সাথে আমাদের ওয়েবসাইটের মাধ্যমে যোগাযোগ করুন। সাপোর্ট প্রক্রিয়া দ্রুত করতে আপনার ডিভাইসের তথ্য প্রস্তুত রাখুন।",
  Community: "সম্প্রদায়",
  "Subscribe.title": "পণ্যের আপডেট পান",
  "Subscribe.subtitle":
    "ক্রিপ্টো ট্রেন্ড আমরা আপনার জন্য অনুসরণ করি। পণ্যের আপডেট, বাজারের অন্তর্দৃষ্টি ও বিশেষ সুবিধা — সরাসরি আপনার ইনবক্সে।",
  "Subscribe.placeholder": "আপনার ইমেইল লিখুন",
  "Subscribe.button": "পণ্যের আপডেটের জন্য সাবস্ক্রাইব করুন",
  "Subscribe.input.aria": "ইমেইল ঠিকানা ইনপুট",
  "Subscribe.success":
    "সাবস্ক্রিপশনের জন্য ধন্যবাদ! অনুগ্রহ করে কনফার্মেশন ইমেইল চেক করুন।",
  "Subscribe.error": "সাবস্ক্রিপশন ব্যর্থ হয়েছে। পরে আবার চেষ্টা করুন।",
  "Subscribe.invalid": "অনুগ্রহ করে একটি বৈধ ইমেইল ঠিকানা দিন।",
  "Subscribe.privacy":
    "আপনার ইমেইল কেবল নিউজলেটার ও আপডেট পাঠাতে ব্যবহার করা হবে। আপনি যেকোনো সময় ইমেইলের লিঙ্ক থেকে আনসাবস্ক্রাইব করতে পারেন।",
  "Subscribe.learnMore":
    "আমরা কীভাবে আপনার ডাটা ও অধিকার পরিচালনা করি, আরও জানুন।",
  "Subscribe.popupCompact.title": "আপডেট থাকুন",
  "Subscribe.popupCompact.subtitle":
    "পণ্যের আপডেট ও নিরাপত্তা তথ্য। কোনো স্প্যাম নয়।",
  "Subscribe.popupCompact.button": "সাবস্ক্রাইব করুন",
  "Subscribe.popupCompact.privacy":
    "শুধু ইমেইল। যেকোনো সময় আনসাবস্ক্রাইব করুন।",
  "SubscribeConfirmed.alt.success": "সাবস্ক্রিপশন নিশ্চিত হয়েছে",
  "SubscribeConfirmed.alt.failed": "সাবস্ক্রিপশন ব্যর্থ হয়েছে",
  "SubscribeConfirmed.title.success": "সাবস্ক্রিপশন নিশ্চিত হয়েছে",
  "SubscribeConfirmed.title.failed": "সাবস্ক্রিপশন ব্যর্থ হয়েছে",
  "SubscribeConfirmed.message.success":
    "আপনার ইমেইল নিশ্চিত করার জন্য ধন্যবাদ। আপনার সাবস্ক্রিপশন এখন সক্রিয়। একটি স্বাগতম ইমেইল আপনার ইনবক্সে পাঠানো হয়েছে।",
  "SubscribeConfirmed.message.failed":
    "নিশ্চিতকরণ লিঙ্কটি অবৈধ বা মেয়াদোত্তীর্ণ। দয়া করে হোমপেজে ফিরে যান এবং আবার সাবস্ক্রাইব করার চেষ্টা করুন।",
  "SubscribeConfirmed.cta.backHome": "হোমপেজে ফিরুন",
  "SubscribeConfirmed.note.unsubscribe":
    "আপনি যেকোনো সময় আমাদের ইমেইলের লিঙ্ক থেকে আনসাবস্ক্রাইব করতে পারেন।",
  // ===== MarketView i18n =====
  "MarketView.title": "মার্কেট ড্যাশবোর্ড",
  "MarketView.loading": "লোড হচ্ছে...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "এই ট্যাব রেন্ডার করতে ব্যর্থ হয়েছে",
  "MarketView.unknownError": "অজানা ত্রুটি",

  // ===== Common i18n =====
  "Common.refresh": "রিফ্রেশ",
  "Common.toggleSeriesVisibility": "এই সিরিজ চালু/বন্ধ করুন",
  "Common.error": "ত্রুটি",
  "Common.dataUpdateTime": "ডেটা আপডেট সময়",
  "Common.loading": "লোড হচ্ছে...",
  "Common.noDataSource": "কোনো ডেটা নেই (ডেটা সোর্স সরবরাহ করা হয়নি)",

  // ===== Common ranges =====
  "Common.to": "থেকে",
  "Common.clear": "পরিষ্কার",
  "Common.range.thisMonth": "এই মাস",
  "Common.range.lastMonth": "গত মাস",
  "Common.range.last2": "গত ২ মাস",
  "Common.range.last3": "গত ৩ মাস",
  "Common.range.last6": "গত ৬ মাস",
  "Common.range.thisYear": "এই বছর",
  "Common.range.all": "সব",
  "Common.range.custom": "কাস্টম",
  "Common.showFilters": "ফিল্টার দেখাও",
  "Common.hideFilters": "ফিল্টার লুকাও",
  "Common.search": "খোঁজ",
  "Common.priority": "অগ্রাধিকার",
  "Common.owner": "দায়িত্বপ্রাপ্ত",
  "Common.collaborator": "সহযোগী",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "ব্যাকএন্ড data/youtube_stats.json ডাউনলোড",
  "YouTubeTab.downloadJson": "youtube_stats.json ডাউনলোড",
  "YouTubeTab.loading": "YouTube মেট্রিকস লোড হচ্ছে...",
  "YouTubeTab.errorHint":
    "API কী কনফিগার করা না থাকলে, backend/.env এ YOUTUBE_API_KEY বা GOOGLE_API_KEY সেট করুন এবং ব্যাকএন্ড রিস্টার্ট করুন।",
  "YouTubeTab.header.totalViews": "মোট ভিউ (মাল্টি-চ্যানেল, একক: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "মোট সাবস্ক্রাইবার (মাল্টি-চ্যানেল, একক: 10k)",
  "YouTubeTab.dist.views": "ভিউ বিতরণ (10k)",
  "YouTubeTab.dist.subscribers": "সাবস্ক্রাইবার বিতরণ (10k)",
  "YouTubeTab.card.location": "অবস্থান:",
  "YouTubeTab.card.registeredAt": "নিবন্ধিত:",
  "YouTubeTab.card.currentSubscribers": "বর্তমান সাবস্ক্রাইবার",
  "YouTubeTab.card.currentVideos": "বর্তমান ভিডিও সংখ্যা",
  "YouTubeTab.card.currentTotalViews": "বর্তমান মোট ভিউ",
  "YouTubeTab.card.currentTotalComments": "বর্তমান মোট মন্তব্য",
  "YouTubeTab.chart.totalSubscribers": "মোট সাবস্ক্রাইবার",
  "YouTubeTab.chart.totalViews": "মোট ভিউ",
  "YouTubeTab.chart.totalComments": "মোট মন্তব্য",
  "YouTubeTab.chart.totalVideos": "মোট ভিডিও",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "ব্যাকএন্ড data/x_stats.json ডাউনলোড",
  "XTab.downloadJson": "x_stats.json ডাউনলোড",
  "XTab.loading": "X মেট্রিকস লোড হচ্ছে...",
  "XTab.errorHint":
    "টোকেন কনফিগার করা না থাকলে, backend/.env এ X_BEARER_TOKEN বা TWITTER_BEARER_TOKEN সেট করুন এবং ব্যাকএন্ড রিস্টার্ট করুন।",
  "XTab.header.totalFollowers": "মোট ফলোয়ার (মাল্টি-চ্যানেল, একক: 10k)",
  "XTab.header.totalEngagement":
    "মোট এনগেজমেন্ট (সর্বশেষ ৫ পোস্ট: লাইক + রিটুইট + রিপ্লাই + কোট, একক: 10k)",
  "XTab.dist.followers": "ফলোয়ার বিতরণ (10k)",
  "XTab.dist.engagement":
    "এনগেজমেন্ট বিতরণ (সর্বশেষ ৫ পোস্ট: লাইক + রিটুইট + রিপ্লাই + কোট, একক: 10k)",
  "XTab.card.currentFollowers": "বর্তমান ফলোয়ার",
  "XTab.card.currentFollowing": "বর্তমান ফলোয়িং",
  "XTab.card.currentTweets": "বর্তমান টুইট সংখ্যা",
  "XTab.card.recentLikes": "সাম্প্রতিক লাইক (সর্বশেষ ৫ পোস্ট)",
  "XTab.card.recentRetweets": "সাম্প্রতিক রিটুইট (সর্বশেষ ৫ পোস্ট)",
  "XTab.card.recentReplies": "সাম্প্রতিক রিপ্লাই (সর্বশেষ ৫ পোস্ট)",
  "XTab.card.recentQuotes": "সাম্প্রতিক ভিউ (কন্টেন্ট-লেভেল, সর্বশেষ ৫ পোস্ট)",
  "XTab.card.listed": "লিস্টেড সংখ্যা (চ্যানেল-লেভেল)",
  "XTab.smallChart.followers": "ফলোয়ার",
  "XTab.smallChart.tweets": "টুইট",
  "XTab.smallChart.likes": "সাম্প্রতিক লাইক",
  "XTab.smallChart.retweets": "সাম্প্রতিক রিটুইট",
  "XTab.smallChart.replies": "সাম্প্রতিক রিপ্লাই",
  "XTab.smallChart.quotes": "সাম্প্রতিক ভিউ (কন্টেন্ট-লেভেল)",
  "XTab.smallChart.following": "ফলোয়িং",
  "XTab.smallChart.listed": "লিস্টেড",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "তৈরির মাস অনুযায়ী ফিল্টার:",
  "Analytics.metric.completionRate": "সম্পন্নের হার",
  "Analytics.metric.teamVelocity": "টিম ভেলোসিটি",
  "Analytics.metric.blockerRatio": "ব্লকার অনুপাত",
  "Analytics.metric.workloadBalance": "ওয়ার্কলোড ব্যালেন্স",
  "Analytics.charts.statusDistribution": "স্ট্যাটাস বিতরণ",
  "Analytics.charts.statusByMonthPercent": "মাসভিত্তিক স্ট্যাটাস (শতাংশ)",
  "Analytics.charts.priorityDistribution": "অগ্রাধিকার বিতরণ",
  "Analytics.charts.priorityByMonthPercent": "মাসভিত্তিক অগ্রাধিকার (শতাংশ)",
  "Analytics.charts.functionTypeDistribution": "ফাংশন টাইপ বিতরণ",
  "Analytics.charts.functionTypeByMonthPercent":
    "মাসভিত্তিক ফাংশন টাইপ (শতাংশ)",
  "Analytics.blocker.ownerPie": "ব্লকড ইস্যু · দায়িত্বপ্রাপ্ত বিতরণ (ডোনাট)",
  "Analytics.blocker.ownerByMonth":
    "ব্লকড ইস্যু · মাসভিত্তিক দায়িত্বপ্রাপ্ত (শতাংশ)",
  "Analytics.bug.ownerPie": "বাগ ইস্যু · দায়িত্বপ্রাপ্ত বিতরণ (ডোনাট)",
  "Analytics.bug.ownerByMonth":
    "বাগ ইস্যু · মাসভিত্তিক দায়িত্বপ্রাপ্ত (শতাংশ)",
  "Analytics.ownerWorkloadDistribution": "টিম ওয়ার্কলোড বিতরণ",
  "Analytics.mode.priority": "অগ্রাধিকার মোড",
  "Analytics.mode.status": "স্ট্যাটাস মোড",
  "Analytics.mode.type": "টাইপ মোড",
  "Analytics.blocker.attentionNeeded": "অবিলম্বে মনোযোগ প্রয়োজন এমন ইস্যু",
  "Analytics.common.status": "স্ট্যাটাস",
  "Analytics.common.owner": "দায়িত্বপ্রাপ্ত",
  "Analytics.insights.sectionTitle": "প্রজেক্ট ইনসাইট ও সুপারিশ",
  "Analytics.insights.efficiency.title": "দক্ষতা উন্নতির সুপারিশ",
  "Analytics.insights.efficiency.completionRate":
    "• বর্তমান সম্পন্নের হার {{rate}}%, ব্লকারগুলোর দিকে নজর দিন",
  "Analytics.insights.efficiency.avgVelocity":
    "• টিমের গড় ভেলোসিটি {{velocity}} টাস্ক/ব্যক্তি",
  "Analytics.insights.efficiency.workloadBalance":
    "• ওয়ার্কলোড ব্যালেন্স {{balance}}%",
  "Analytics.insights.risk.title": "ঝুঁকি সতর্কতা",
  "Analytics.insights.risk.blockerRatio": "• ব্লকার অনুপাত {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 ইস্যুর অনুপাত {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• উচ্চ অগ্রাধিকার ইস্যুগুলো আগে সমাধান করুন",

  // ===== Kanban i18n =====
  "Kanban.title": "কানবান ভিউ",
  "Kanban.totalIssues": "মোট {{count}}টি ইস্যু",
  "Kanban.searchPlaceholder":
    "শিরোনাম, ইস্যু নম্বর, দায়িত্বপ্রাপ্ত বা সহযোগী খুঁজুন...",
  "Kanban.status.backlog": "ব্যাকলগ",
  "Kanban.status.inProgress": "চলমান",
  "Kanban.status.blocked": "বাধাগ্রস্ত / নিশ্চিতকরণের অপেক্ষায়",
  "Kanban.status.reviewTest": "রিভিউ / টেস্ট",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "ইস্যু তালিকা",
  "List.totalIssues": "মোট {{count}}টি ইস্যু",
  "List.viewDetails": "বিস্তারিত দেখুন",
  "List.openInNewWindow": "নতুন উইন্ডোতে খুলুন",
  "List.empty.title": "কোনো ইস্যু নেই",
  "List.empty.subtitle": "ওয়ার্কফ্লো শুরু করতে প্রথম ইস্যুটি তৈরি করুন",

  // ===== Assets Register i18n =====
  "Assets.title": "সম্পদ নিবন্ধন",
  "Assets.totalSets": "মোট সেট",
  "Assets.table.employee": "কর্মচারী",
  "Assets.table.setCount": "সেট",
  "Assets.table.model": "মডেল",
  "Assets.total": "মোট",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "প্রকল্প ইস্যু ট্র্যাকিং",
  "LukkeyIssues.goToDemo": "ডেমো পেজে যান",
  "LukkeyIssues.githubProject": "GitHub প্রকল্প ↗",
  "LukkeyIssues.githubManageIssues": "GitHub-এ সরাসরি Issues পরিচালনা করুন ↗",
  "LukkeyIssues.financeModel": "ফাইন্যান্স মডেল",
  "LukkeyIssues.productCoreIssues": "পণ্যের মূল ইস্যু",
  "LukkeyIssues.stats.totalIssues": "📊 মোট ইস্যু",
  "LukkeyIssues.stats.completed": "✅ সম্পন্ন",
  "LukkeyIssues.stats.inProgress": "🔄 চলমান",
  "LukkeyIssues.stats.pending": "⏳ মুলতুবি",
  "LukkeyIssues.stats.blocked": "🚫 বাধাগ্রস্ত",
  "LukkeyIssues.stats.docs": "📚 ডকস",
  "LukkeyIssues.tabs.kanban": "কানবান ভিউ",
  "LukkeyIssues.tabs.analytics": "অ্যানালিটিক্স",
  "LukkeyIssues.tabs.market": "মার্কেট ড্যাশবোর্ড",
  "LukkeyIssues.tabs.assets": "সম্পদ নিবন্ধন",
  "LukkeyIssues.shareToChatGPT": "ChatGPT দিয়ে LUKKEY.json খুলুন", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY গোপনীয়তা নীতি",
  "PrivacyPolicy.intro.p1":
    "LUKKEY‑এ আমরা বিশ্বাস করি, সবচেয়ে নিরাপদ গোপনীয়তা হলো সেটি যা সবসময় ব্যবহারকারীর নিজের হাতেই থাকে।",
  "PrivacyPolicy.intro.p2":
    "তাই আপনি LUKKEY হার্ডওয়্যার কোল্ড ওয়ালেট বা LUKKEY মোবাইল অ্যাপ (App) যেটাই ব্যবহার করুন না কেন, আমরা একটি অবিচল নীতি কঠোরভাবে মেনে চলি:",
  "PrivacyPolicy.intro.p3_strong":
    "ব্যবহারকারী স্পষ্টভাবে অনুমতি না দিলে আমরা কোনো ব্যবহারকারীর তথ্য সংগ্রহ, সংরক্ষণ বা আপলোড করি না।",
  "PrivacyPolicy.intro.p3_tail":
    "ব্যবহারের সাথে সম্পর্কিত সব তথ্য কেবলমাত্র ব্যবহারকারীর ডিভাইসে স্থানীয়ভাবে সংরক্ষিত থাকে এবং কখনোই LUKKEY বা কোনো সার্ভারে প্রেরণ করা হয় না।",
  "PrivacyPolicy.intro.p4":
    "এই গোপনীয়তা নীতি আমরা কীভাবে এই নীতিকে বাস্তবায়ন করি তা ব্যাখ্যা করে।",

  "PrivacyPolicy.s1.title": "1. প্রয়োগের ক্ষেত্র",
  "PrivacyPolicy.s1.appliesTo": "এই গোপনীয়তা নীতি প্রযোজ্য:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY হার্ডওয়্যার কোল্ড ওয়ালেট",
  "PrivacyPolicy.s1.item.app": "LUKKEY মোবাইল অ্যাপ (App)",
  "PrivacyPolicy.s1.principle":
    "উভয়ই একীভূত গোপনীয়তা নীতি “শূন্য সংগ্রহ, শূন্য আপলোড, কেবল স্থানীয় সংরক্ষণ” অনুসরণ করে।",

  "PrivacyPolicy.s2.title": "2. আমরা যে তথ্য সংগ্রহ করি না",
  "PrivacyPolicy.s2.desc":
    "আপনার গোপনীয়তা রক্ষার্থে, আমরা স্পষ্টভাবে অঙ্গীকার করি যে কোনো ব্যবহারকারীর তথ্য সংগ্রহ, আপলোড বা সংরক্ষণ করি না, যার মধ্যে রয়েছে (কিন্তু সীমাবদ্ধ নয়):",
  "PrivacyPolicy.s2.li.identity":
    "পরিচয় সংক্রান্ত তথ্য: নাম, ফোন নম্বর, ই‑মেইল ঠিকানা, ডাক ঠিকানা",
  "PrivacyPolicy.s2.li.walletSensitive":
    "ওয়ালেটের সংবেদনশীল তথ্য: প্রাইভেট কী, ম্নেমনিক ফ্রেজ, keystore ফাইল, ওয়ালেট পাসওয়ার্ড",
  "PrivacyPolicy.s2.li.blockchain":
    "ব্লকচেইন তথ্য: ওয়ালেট ঠিকানা, লেনদেনের ইতিহাস, সম্পদের তথ্য",
  "PrivacyPolicy.s2.li.behavior":
    "ব্যবহারের আচরণ: অ্যাপ লগ, ক্লিক রেকর্ড, আচরণগত বিশ্লেষণ",
  "PrivacyPolicy.s2.li.technical":
    "প্রযুক্তিগত তথ্য: ডিভাইস আইডেন্টিফায়ার, ভূ‑অবস্থান, IP ঠিকানা",
  "PrivacyPolicy.s2.inShort.title": "সংক্ষেপে:",
  "PrivacyPolicy.s2.inShort.desc":
    "হার্ডওয়্যার ডিভাইস ও অ্যাপে যা কিছু দেখেন, তা শুধু আপনার ডিভাইসেই থাকে। LUKKEY সেটিতে প্রবেশ করতে পারে না।",

  "PrivacyPolicy.s3.title":
    "3. হার্ডওয়্যার কোল্ড ওয়ালেটের গোপনীয়তা ও নিরাপত্তা নকশা",
  "PrivacyPolicy.s3.desc":
    "LUKKEY কোল্ড ওয়ালেট সম্পূর্ণ অফলাইন ও সুরক্ষিত পরিবেশ প্রদান করে। প্রধান বৈশিষ্ট্য:",
  "PrivacyPolicy.s3.h1.title": "1. সামরিক‑মানের সিকিউরিটি হার্ডওয়্যার",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ সার্টিফায়েড Secure Element",
  "PrivacyPolicy.s3.h1.l2": "হার্ডওয়্যার‑লেভেলে সম্পূর্ণ এনক্রিপ্টেড যোগাযোগ",
  "PrivacyPolicy.s3.h2.title": "2. নিরাপত্তা ফাংশন",
  "PrivacyPolicy.s3.h2.l1": "ফিঙ্গারপ্রিন্ট প্রমাণীকরণ",
  "PrivacyPolicy.s3.h2.l2": "প্রাইভেসি মোড",
  "PrivacyPolicy.s3.h2.l3": "মাল্টি‑ওয়ালেট বিচ্ছিন্ন ব্যবস্থাপনা",
  "PrivacyPolicy.s3.h3.title": "3. সম্পূর্ণ বিচ্ছিন্নতা",
  "PrivacyPolicy.s3.h3.l1": "ইন্টারনেট সংযোগ নেই",
  "PrivacyPolicy.s3.h3.l2": "ডেটা‑কেবল সংযোগ নেই",
  "PrivacyPolicy.s3.h4.title": "4. ট্যাম্পার‑রেজিস্ট্যান্ট স্ব‑ধ্বংস",
  "PrivacyPolicy.s3.h4.desc":
    "ডিভাইস খুলে ফেললে, ক্ষতিগ্রস্ত হলে বা অস্বাভাবিক অনুপ্রবেশ হলে, Secure Element স্বয়ংক্রিয়ভাবে সংবেদনশীল ডেটা ধ্বংস করে, যাতে প্রাইভেট কী বের করা না যায়।",
  "PrivacyPolicy.s3.h5.title":
    "5. সংবেদনশীল কাজ শুধুমাত্র Secure Element‑এর ভিতরে",
  "PrivacyPolicy.s3.h5.l1": "ওয়ালেট তৈরি",
  "PrivacyPolicy.s3.h5.l2": "ওয়ালেট আমদানি",
  "PrivacyPolicy.s3.h5.l3": "লেনদেন স্বাক্ষর",
  "PrivacyPolicy.s3.h5.note":
    "সব সংবেদনশীল প্রক্রিয়া 100% Secure Element‑এর ভিতরেই সম্পন্ন হয় এবং কোনো অনিরাপদ চিপ বা স্টোরেজ এলাকায় কখনো এক্সপোজ হয় না।",
  "PrivacyPolicy.s3.h6.title":
    "6. Secure Element‑এর বাইরে সংবেদনশীল তথ্য সংরক্ষণ নয়",
  "PrivacyPolicy.s3.h6.desc":
    "ডিভাইসের অনিরাপদ স্টোরেজ এলাকায় প্রাইভেট কী, ম্নেমনিক বা কোনো সংবেদনশীল তথ্য রাখা হয় না।",

  "PrivacyPolicy.s4.title": "4. LUKKEY App‑এর গোপনীয়তা ও নিরাপত্তা নকশা",
  "PrivacyPolicy.s4.desc":
    "LUKKEY App কেবল তথ্য প্রদর্শন ও নোটিফিকেশন দেয়; এটি ওয়ালেটের সংবেদনশীল ডেটা হ্যান্ডেল করে না।",
  "PrivacyPolicy.s4.n1.title": "1. App যা করে না",
  "PrivacyPolicy.s4.n1.l1": "ব্লকচেইন ওয়ালেট তৈরি করে না",
  "PrivacyPolicy.s4.n1.l2": "ব্লকচেইন ওয়ালেট ইমপোর্ট করে না",
  "PrivacyPolicy.s4.n1.l3": "প্রাইভেট কী বা ম্নেমনিক সংরক্ষণ করে না",
  "PrivacyPolicy.s4.n1.l4": "কোনো ব্যবহারকারীর ডেটা আপলোড করে না",
  "PrivacyPolicy.s4.n1.l5":
    "আচরণগত বিশ্লেষণ, বিজ্ঞাপন ট্র্যাকিং বা ডেটা সংগ্রহ করে না",
  "PrivacyPolicy.s4.n2.title": "2. App যা করে",
  "PrivacyPolicy.s4.n2.l1":
    "হার্ডওয়্যার দ্বারা অনুমোদিত সর্বজনীনভাবে দৃশ্যমান তথ্য দেখায়",
  "PrivacyPolicy.s4.n2.l2":
    "প্রতিটি পারমিশনের উদ্দেশ্য ব্যাখ্যা‑সহ প্রাইভেসি সেটিংস প্যানেল দেয়",
  "PrivacyPolicy.s4.n2.l3":
    "ব্যবহারকারী যেকোনো সময় পারমিশন চালু/বন্ধ করার পূর্ণ নিয়ন্ত্রণ পায়",
  "PrivacyPolicy.s4.n2.l4": "সংবেদনশীল তথ্য মাস্কিং প্রদান করে",
  "PrivacyPolicy.s4.n2.l5": "কিছু ভিউ‑তে স্ক্রিনশট/রেকর্ডিং নিষ্ক্রিয় করে",
  "PrivacyPolicy.s4.n2.l6":
    "লোকাল ম্যাচিং‑এর মাধ্যমে সন্দেহজনক ব্লকচেইন ঠিকানা সনাক্ত করে",
  "PrivacyPolicy.s4.n2.l7":
    "ঝুঁকিপূর্ণ URL, কনট্র্যাক্ট ও ঠিকানার তালিকা নিয়মিত আপডেট করে",
  "PrivacyPolicy.s4.n2.l8": "আপডেটের প্রবাহ একমুখী: কেবল সার্ভার → ডিভাইস",
  "PrivacyPolicy.s4.n2.l9":
    "আপডেটের সময় কোনো ব্যবহারকারী ডেটা কখনো ফেরত পাঠানো হয় না",
  "PrivacyPolicy.s4.n3.title": "3. স্থানীয় সংরক্ষণ",
  "PrivacyPolicy.s4.n3.p1":
    "App কেবল UI প্রিফারেন্স, ভাষা, থিম সেটিংসের মতো অ‑ব্যক্তিগত তথ্য স্থানীয়ভাবে সংরক্ষণ করে। এই ডেটা:",
  "PrivacyPolicy.s4.n3.l1": "আপলোড করা হয় না",
  "PrivacyPolicy.s4.n3.l2": "সিঙ্ক করা হয় না",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY‑এর কাছে প্রবেশযোগ্য নয়",

  "PrivacyPolicy.s5.title": "5. ডেটা প্রেরণ ও সার্ভার নীতি",
  "PrivacyPolicy.s5.l1": "LUKKEY সার্ভার কোনো ব্যবহারকারীর তথ্য সংরক্ষণ করে না",
  "PrivacyPolicy.s5.l2":
    "App–সার্ভার যোগাযোগ কেবল ডাটাবেস ও ভার্সন আপডেটে সীমাবদ্ধ",
  "PrivacyPolicy.s5.l3":
    "যোগাযোগ চলাকালে কোনো ব্যবহারকারীর তথ্য প্রেরণ করা হয় না",
  "PrivacyPolicy.s5.l4":
    "সার্ভার ক্ষতিগ্রস্ত হলেও কোনো ব্যবহারকারী ডেটা ফাঁস হতে পারে না, কারণ আমরা সেসব ডেটা আদৌ সংগ্রহ করি না",

  "PrivacyPolicy.s6.title": "6. ওপেন‑সোর্স স্বচ্ছতা",
  "PrivacyPolicy.s6.l1": "LUKKEY App‑এর সোর্স কোড ওপেন‑সোর্স",
  "PrivacyPolicy.s6.l2":
    "LUKKEY হার্ডওয়্যারের এমবেডেড ফার্মওয়্যার ওপেন‑সোর্স",
  "PrivacyPolicy.s6.l3": "GitHub‑এ সম্পূর্ণ উন্মুক্ত, যে কেউ অডিট করতে পারে",
  "PrivacyPolicy.s6.p": "স্বচ্ছতা নিরাপত্তার একটি অংশ।",

  "PrivacyPolicy.s7.title": "7. ব্যবহারকারীর পূর্ণ নিয়ন্ত্রণ",
  "PrivacyPolicy.s7.p":
    "আমরা ব্যবহারকারীর তথ্য সংগ্রহ করি না—তবু ব্যবহারকারী তার ডিভাইসের উপর সম্পূর্ণ নিয়ন্ত্রণ রাখেন:",
  "PrivacyPolicy.s7.l1": "আপনি যেকোনো সময় App‑এর পারমিশন বন্ধ করতে পারেন",
  "PrivacyPolicy.s7.l2":
    "আপনি App আনইনস্টল করে সব স্থানীয় App ডেটা মুছে দিতে পারেন",
  "PrivacyPolicy.s7.l3":
    "আপনি হার্ডওয়্যার ডিভাইস রিসেট করে প্রাইভেট কী ও ওয়ালেট ডেটা স্থায়ীভাবে মুছে দিতে পারেন",
  "PrivacyPolicy.s7.p2":
    "LUKKEY এসব পদক্ষেপে হস্তক্ষেপ করে না এবং করতে পারে না।",

  "PrivacyPolicy.s8.title": "8. আমাদের সাথে যোগাযোগ করুন",
  "PrivacyPolicy.s8.p":
    "এই গোপনীয়তা নীতি সম্পর্কিত কোনো প্রশ্ন থাকলে আমাদের সাথে যোগাযোগ করুন:",
  "PrivacyPolicy.s8.email": "ই‑মেইল: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "ঠিকানা: LUKKEY সদর দপ্তর, Baarerstrasse 25, 6300 Zug, Switzerland",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "পরীক্ষা চলছে...",
  "EmailOtp.title": "প্রবেশ সীমিত: লগইন কোড পেতে নাম ও ই‑মেইল দিন",
  "EmailOtp.nameLabel": "নাম",
  "EmailOtp.namePlaceholder": "আপনার নাম লিখুন",
  "EmailOtp.emailLabel": "ই‑মেইল",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "কোড পাঠান",
  "EmailOtp.resendCode": "কোড আবার পাঠান",
  "EmailOtp.resendWithCountdown": "{{s}} সেকেন্ড পরে আবার পাঠান",
  "EmailOtp.codeValidityHint":
    "যাচাইকরণ কোড ৫ মিনিটের জন্য বৈধ। এটি কারও সাথে শেয়ার করবেন না।",
  "EmailOtp.codeLabel": "ই‑মেইল যাচাইকরণ কোড",
  "EmailOtp.codePlaceholder": "প্রাপ্ত কোড লিখুন",
  "EmailOtp.signIn": "সাইন ইন",
  "EmailOtp.message.codeSent": "যাচাইকরণ কোড আপনার ই‑মেইলে পাঠানো হয়েছে।",
  "EmailOtp.error.nameRequired": "নাম প্রয়োজন",
  "EmailOtp.error.invalidEmail": "সঠিক ই‑মেইল ঠিকানা লিখুন",
  "EmailOtp.error.sendFailed": "কোড পাঠাতে ব্যর্থ। পরে আবার চেষ্টা করুন।",
  "EmailOtp.error.codeRequired": "অনুগ্রহ করে যাচাইকরণ কোড লিখুন",
  "EmailOtp.error.verificationFailed": "যাচাইকরণ ব্যর্থ হয়েছে",
  // ===== Academy i18n =====
  "Academy.hero.alert": "নিরাপত্তা স্মরণ: সর্বদা লিঙ্ক যাচাই করুন, কখনও পুনরুদ্ধার ফ্রেজ শেয়ার করবেন না।",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "একাডেমি",
  "Academy.hero.subtitle": "ক্রিপ্টো নিরাপত্তা, স্ব-রক্ষণাবেক্ষণ এবং LUKKEY কোল্ড ওয়ালেট ব্যবহারের ব্যবহারিক গাইড।",
  "Academy.search.placeholder": "টিউটোরিয়াল, বেস্ট প্র্যাকটিস ও সাধারণ প্রশ্ন খুঁজুন…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "প্রবন্ধ",
  "Academy.list.title": "সর্বশেষ গাইড",
  "Academy.list.viewAll": "সব দেখুন",
  "Academy.list.empty": "কোন ফলাফল নেই। অন্য কীওয়ার্ড চেষ্টা করুন।",
  "Academy.image.placeholder": "ছবি",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "একাডেমিতে ফিরে যান",
  "AcademyArticle.notFound": "প্রবন্ধ পাওয়া যায়নি",
  "AcademyArticle.author": "লেখক",
  "AcademyArticle.unscheduled": "নির্ধারিত প্রকাশের সময় নেই",
  "home.hero.reserveCtaLabel": "আগাম অ্যাক্সেস — $1",
  "home.hero.reserveCtaNote": "সম্পূর্ণ ফেরতযোগ্য। কেনার কোনো বাধ্যবাধকতা নেই।"
};
export default translation;
